module.exports = __webpack_public_path__ + "static/fitnessEquipment-9c8e4244f0b7c3deb32a1e17738a583d.png";